import ReactGA from 'react-ga'

export default () => {
  ReactGA.initialize('UA-97191132-1', {
    debug: false,
    trace: false,
    testMode: process.env.NODE_ENV === 'test'
  })

  ReactGA.ga('create', 'UA-97191132-10', 'auto', { name: 'intervu' })

  if (process.env.NODE_ENV === 'development') {
    ReactGA.ga('set', 'sendHitTask', null)
  }
}



// WEBPACK FOOTER //
// ./src/config/analytics.js